import {
  ContactPurpose,
  Customer,
  LeaseApplication,
  LegalForm,
  MainIndustry,
  Partner,
  Status,
  Type,
} from '../types/instant-lease-api';

export const bankDetails = {
  valid: true,
  messages: ['Bank code valid: 096'],
  iban: 'DE73200700000010080000',
  bankData: {
    bankCode: '096',
    name: 'BELFIUS BANK',
    bic: 'GKCCBEBB',
  },
  checkResults: {
    bankCode: true,
  },
};

export const aCustomer: Customer = {
  company: {
    name: 'Fancy Stuff TM',
    main_industry: MainIndustry.ENERGY,
    establishment_date: '01.01.2001',
    trade_registry_number: 'HRE 1234',
    website_url: 'https://example.com',
    car_pool_size: 0,
    contact_details: {
      emails: [
        {
          value: 'contact@example.com',
          purpose: ContactPurpose.CONTACT,
        },
        {
          value: 'sepa@example.com',
          purpose: ContactPurpose.SEPA,
        },
        {
          value: 'invoice@example.com',
          purpose: ContactPurpose.INVOICE,
        },
      ],
      phone_numbers: [
        {
          value: '+491234567890',
          purpose: ContactPurpose.CONTACT,
        },
      ],
      addresses: [
        {
          street_line: 'somewhere street',
          postal_code: '12345',
          locality: 'Far Far Away',
        },
      ],
    },
    bank_account: {
      iban: bankDetails.iban,
      bic: bankDetails.bankData.bic,
      bank_name: bankDetails.bankData.name,
    },
    legal_form: LegalForm.EINGETRAGENER_KAUFMANN,
    signers: [
      {
        uuid: '1',
        person: {
          uuid: '1',
          first_name: 'Max',
          last_name: 'Musterman',
          checked: true,
        },
      },
      {
        uuid: '1',
        person: {
          uuid: '2',
          first_name: 'John',
          last_name: 'Wick',
          checked: true,
        },
      },
    ],
    authorized_representatives: [
      {
        uuid: '1',
        person: { uuid: '1', first_name: 'Max', last_name: 'Musterman' },
      },
    ],
    beneficial_owners: [
      {
        uuid: '2',
        person: { uuid: '1', first_name: 'Max', last_name: 'Musterman' },
      },
    ],
  },
};

export const aLeaseApplication: LeaseApplication = {
  uuid: 'some-uuid',
  creator: 'auth0|random string',
  timestamp: '2020-09-30T09:40:13.170359Z',
  offer: {
    armada_id: '350356673',
  },
  state: Status.CREATED,
  type: Type.B2B,
  partner: Partner.ALD,
  customer: aCustomer,
  last_changed: '2020-09-30T09:40:13.170359Z',
  registered_documents: [
    {
      creation_time: '2021-03-01T15:59:11.776Z',
      document_type: 'passport',
      file_name: 'example.png',
      file_size: 7528,
      md5hash: 'anymd5hash',
      mime_type: 'image/png',
      token: 'anytoken',
    },
  ],
};

export const aLeaseAppWithoutOffer: LeaseApplication = {
  uuid: 'some-uuid',
  creator: 'auth0|random string',
  acting_person: {
    email: 'foobar@example.com',
    first_name: 'Foo',
    last_name: 'Bar',
  },
  timestamp: '2020-09-30T09:40:13.170359Z',
  state: Status.CREATED,
  type: Type.B2B,
  partner: Partner.ALD,
  customer: aCustomer,
  last_changed: '2020-09-30T09:40:13.170359Z',
};

export const aLeaseAppWithVehicleData: LeaseApplication = {
  uuid: 'some-uuid',
  creator: 'auth0|random string',
  acting_person: {
    email: 'foobar@example.com',
    first_name: 'Foo',
    last_name: 'Bar',
  },
  timestamp: '2020-09-30T09:40:13.170359Z',
  offer: {
    armada_id: '350356673',
    vehicle_data: {
      key: '40803448',
      model_id: '3066',
      name: 'e-Niro',
      vehicleImageUrl: 'some-url',
      full_name: 'KIA e-Niro Edition 7',
      colors: {
        paint: { equipment_code: '330815', color_code: '25353' },
        paint_naming: {
          equipment_name: 'Lackierung: Metallic',
          color_code_name: 'Runway Red Metallic',
        },
        cushion: { equipment_code: '330665', color_code: '20555' },
        cushion_naming: {
          equipment_name: 'Polster: Stoff-Leder-Kombination',
        },
      },
    },
    leasing_options: {
      created: '2021-03-23 14:18:05',
      mileage: 20000,
      duration: 48,
      finance: {
        rate: { net: 409.85, gross: 487.72 },
        exceeding_mileage: { net: 7.54, gross: 8.97 },
        inferior_mileage: { net: 2.49, gross: 2.96 },
        interest: { effective: 4.594, nominal: 4.5 },
        leasing_factor: 1.35818,
      },
      maintenance: {
        rate: { net: 28.38, gross: 33.77 },
        exceeding_mileage: { net: 2.21, gross: 2.63 },
        inferior_mileage: { net: 0.66, gross: 0.66 },
      },
      totals: {
        rate: { net: 438.23, gross: 521.49 },
        payment: { net: 21035.04, gross: 25031.52 },
        exceeding_mileage: { net: 9.75, gross: 11.6 },
        inferior_mileage: { net: 3.15, gross: 3.62 },
      },
      service_rate: { net: 28.38, gross: 33.77 },
    },
  },
  state: Status.CREATED,
  type: Type.B2B,
  partner: Partner.ALD,
  customer: aCustomer,
  last_changed: '2020-09-30T09:40:13.170359Z',
  registered_documents: [
    {
      creation_time: '2021-03-01T15:59:11.776Z',
      document_type: 'passport',
      file_name: 'example.png',
      file_size: 7528,
      md5hash: 'anymd5hash',
      mime_type: 'image/png',
      token: 'anytoken',
    },
  ],
};

export const anotherLeaseApplication: LeaseApplication = {
  uuid: 'another uuid',
  creator: 'auth0|random string',
  acting_person: {
    email: 'blargh@example.com',
    first_name: 'Bla',
    last_name: 'Argh',
  },
  timestamp: '2020-09-30T09:40:13.170359Z',
  offer: {
    armada_id: 'another armada offer id',
  },
  state: Status.CREATED,
  type: Type.B2B,
  partner: Partner.ALD,
  customer: aCustomer,
  last_changed: '2020-09-30T09:40:13.170359Z',
  registered_documents: [
    {
      creation_time: '2021-03-01T15:59:11.776Z',
      document_type: 'passport',
      file_name: 'example.png',
      file_size: 7528,
      md5hash: 'anymd5hash',
      mime_type: 'image/png',
      token: 'anytoken',
    },
  ],
};

export const anotherLeaseAppWithVehicleData: LeaseApplication = {
  uuid: 'another uuid',
  creator: 'auth0|random string',
  acting_person: {
    email: 'blargh@example.com',
    first_name: 'Bla',
    last_name: 'Argh',
  },
  timestamp: '2020-09-30T09:40:13.170359Z',
  offer: {
    armada_id: '350356673',
    vehicle_data: {
      key: '40803448',
      model_id: '3066',
      name: 'e-Niro',
      vehicleImageUrl: undefined,
      full_name: 'KIA e-Niro Edition 8',
      colors: {
        paint: { equipment_code: '330815', color_code: '25353' },
        paint_naming: {
          equipment_name: 'Lackierung: Metallic',
          color_code_name: 'Runway Red Metallic',
        },
        cushion: { equipment_code: '330665', color_code: '20555' },
        cushion_naming: {
          equipment_name: 'Polster: Stoff-Leder-Kombination',
        },
      },
    },
    leasing_options: {
      created: '2021-03-23 14:18:05',
      mileage: 20000,
      duration: 48,
      finance: {
        rate: { net: 409.85, gross: 487.72 },
        exceeding_mileage: { net: 7.54, gross: 8.97 },
        inferior_mileage: { net: 2.49, gross: 2.96 },
        interest: { effective: 4.594, nominal: 4.5 },
        leasing_factor: 1.35818,
      },
      maintenance: {
        rate: { net: 28.38, gross: 33.77 },
        exceeding_mileage: { net: 2.21, gross: 2.63 },
        inferior_mileage: { net: 0.66, gross: 0.66 },
      },
      totals: {
        rate: { net: 438.23, gross: 521.49 },
        payment: { net: 21035.04, gross: 25031.52 },
        exceeding_mileage: { net: 9.75, gross: 11.6 },
        inferior_mileage: { net: 3.15, gross: 3.62 },
      },
      service_rate: { net: 28.38, gross: 33.77 },
    },
  },
  state: Status.CREATED,
  type: Type.B2B,
  partner: Partner.ALD,
  customer: aCustomer,
  last_changed: '2020-09-30T09:40:13.170359Z',
  registered_documents: [
    {
      creation_time: '2021-03-01T15:59:11.776Z',
      document_type: 'passport',
      file_name: 'example.png',
      file_size: 7528,
      md5hash: 'anymd5hash',
      mime_type: 'image/png',
      token: 'anytoken',
    },
  ],
};

const aCustomerWithoutRep: Customer = {
  company: {
    name: 'Fancy Stuff TM',
    main_industry: MainIndustry.ENERGY,
    establishment_date: '2001-01-01',
    trade_registry_number: 'HRE 1234',
    website_url: 'https://example.com',
    contact_details: {
      emails: [
        {
          value: 'contact@example.com',
          purpose: ContactPurpose.CONTACT,
        },
        {
          value: 'sepa@example.com',
          purpose: ContactPurpose.SEPA,
        },
        {
          value: 'invoice@example.com',
          purpose: ContactPurpose.INVOICE,
        },
      ],
      phone_numbers: [
        {
          value: '+491234567890',
          purpose: ContactPurpose.CONTACT,
        },
      ],
      addresses: [
        {
          street_line: 'somewhere street',
          postal_code: '12345',
          locality: 'Far Far Away',
        },
      ],
    },
    bank_account: {
      iban: bankDetails.iban,
      bic: bankDetails.bankData.bic,
      bank_name: bankDetails.bankData.name,
    },
    car_pool_size: 0,
    legal_form: LegalForm.EINGETRAGENER_KAUFMANN,
  },
};

const aCustomerWithoutBankAccount: Customer = {
  company: {
    name: 'Fancy Stuff TM',
    main_industry: MainIndustry.ENERGY,
    establishment_date: '2001-01-01',
    contact_details: {
      emails: [
        {
          value: 'contact@example.com',
          purpose: ContactPurpose.CONTACT,
        },
        {
          value: 'sepa@example.com',
          purpose: ContactPurpose.SEPA,
        },
        {
          value: 'invoice@example.com',
          purpose: ContactPurpose.INVOICE,
        },
      ],
      phone_numbers: [
        {
          value: '+491234567890',
          purpose: ContactPurpose.CONTACT,
        },
      ],
      addresses: [
        {
          street_line: 'somewhere street',
          postal_code: '12345',
          locality: 'Far Far Away',
        },
      ],
    },
    trade_registry_number: 'HRE 1234',
    website_url: 'https://example.com',
    car_pool_size: 0,
    legal_form: LegalForm.EINGETRAGENER_KAUFMANN,
  },
};

export const aLeaseAppWithoutCompanyRep: LeaseApplication = {
  uuid: 'some-uuid',
  creator: 'auth0|random string',
  acting_person: {
    email: 'foobar@example.com',
    first_name: 'Foo',
    last_name: 'Bar',
  },
  timestamp: '2020-09-30T09:40:13.170359Z',
  offer: {
    armada_id: 'some armada offer id',
  },
  state: Status.CREATED,
  type: Type.B2B,
  customer: aCustomerWithoutRep,
  partner: Partner.ALD,
  last_changed: '2020-09-30T09:40:13.170359Z',
};

export const aLeaseAppWithoutCustomerBankAccount: LeaseApplication = {
  uuid: 'some-uuid',
  creator: 'auth0|random string',
  acting_person: {
    email: 'foobar@example.com',
    first_name: 'Foo',
    last_name: 'Bar',
  },
  timestamp: '2020-09-30T09:40:13.170359Z',
  offer: {
    armada_id: 'some armada offer id',
  },
  customer: aCustomerWithoutBankAccount,
  state: Status.CREATED,
  type: Type.B2B,
  partner: Partner.ALD,
  last_changed: '2020-09-30T09:40:13.170359Z',
};

export const aLeaseAppWithoutCustomer: LeaseApplication = {
  uuid: 'some-uuid',
  creator: 'auth0|random string',
  acting_person: {
    email: 'foobar@example.com',
    first_name: 'Foo',
    last_name: 'Bar',
  },
  timestamp: '2020-09-30T09:40:13.170359Z',
  offer: {
    armada_id: 'some armada offer id',
  },
  state: Status.CREATED,
  type: Type.B2B,
  partner: Partner.ALD,
  last_changed: '2020-09-30T09:40:13.170359Z',
};

export const defaultLeaseApplication = {
  uuid: '08937efa-43dd-478d-bc63-218561d68b77',
  type: Type.B2C,
  // type: Type.B2B,
  created_by: {
    person: {
      uuid: '13587ac4-0dcd-4c15-8627-35c5d8d482e0',
      first_name: 'Mohammed',
      last_name: 'Mahmoud',
      nationality: 'NATIONALITY_UNSPECIFIED',
      contact_details: {
        emails: [{ value: 'mo.mahmoudde@gmail.com' }],
        phone_numbers: [],
        addresses: [],
      },
      identity_documents: [],
    },
    auth_subject: 'auth0|5f7af191a410fe0068a535a8',
    authorities: [],
  },
  created_timestamp: '2022-09-06T07:25:43Z',
  modified_timestamp: '2022-09-06T07:25:43Z',
  state: Status.CREATED,
  flow: 'LEASE_APPLICATION_FLOW_LOCAL',
  partner: Partner.SMART,
  registered_documents: [],
  documents: [],
  vin: '',
  offer: {
    armada_id: '120656392',
    partner_order_id: '',
    vehicle_data: {
      key: 20215057,
      model_id: 2770,
      name: 'Transit 310 L2H2 Lkw VA',
      brand: 'FORD',
      full_name: 'Ford Transit 310 L2H2 Lkw VA Basis',
      vehicleImageUrl:
        'https://aldshowroom.blob.ald.digital/armsgeneratedimages/66d5aea2fad51d7a7e7008ff1725439216313.jpg',
      colors: {
        paint: {
          equipment_code: 124386,
          color_code: 28685,
        },
        paint_naming: {
          equipment_name: 'Lackierung: Metallic',
          color_code_name: 'Agate Black Metallic',
        },
        cushion: {
          equipment_code: 397476,
          color_code: 31169,
        },
        cushion_naming: {
          equipment_name: 'Sitze: Sitz-Paket 6A',
        },
      },
      emission_data: {
        co2: '16',
        consumptionAndEmissionTest: 'WLTP',
        fuelType: 'Diesel',
        totalPrice: '41200.0',
        usedMileage: '0',
      },
      additional_cost: {
        freight: 356,
        logistics: 0,
        registration: 0,
        returnFreight: 0,
      },
    },
    leasing_options: {
      id: '',
      created: '2024-09-10T15:07:19+02:00',
      mileage: 10000,
      duration: 48,
      finance: {
        rate: {
          net: 596.28,
          gross: 709.57,
        },
        exceeding_mileage: {
          net: 10.1,
          gross: 12.02,
        },
        inferior_mileage: {
          net: 3.33,
          gross: 3.96,
        },
        interest: {
          effective: 8.289,
          nominal: 7.99,
        },
        leasing_factor: 1.47594,
      },
      maintenance: {
        rate: { net: 1, gross: 2 },
        exceeding_mileage: { net: 1, gross: 2 },
        inferior_mileage: { net: 1, gross: 2 },
      },
      insurance: {},
      fuelCard: {},
      summerTires: {
        amount: 0,
        front: '',
        rear: '',
      },
      winterTires: {
        amount: 0,
        front: '',
        rear: '',
      },
      totals: {
        rate: {
          net: 596.28,
          gross: 709.57,
        },
        payment: {
          net: 31621.44,
          gross: 37629.36,
        },
        exceeding_mileage: {
          net: 10.1,
          gross: 12.02,
        },
        inferior_mileage: {
          net: 3.33,
          gross: 3.96,
        },
      },
      service_rate: {
        net: 0,
        gross: 0,
      },
      downPayment: {
        net: 3000,
        gross: 3570,
      },
    },
    publication: {
      publication_id: '66e014d74ee32343272b26a3',
      pricing_id: '66e014d74ee32343272b268b',
    },
    dealer: {
      partner: 'ald_marktplatz',
      id: '3604',
      partner_id: '',
      name1: 'Krüll Motor Company GmbH & Co. KG',
      brand: 'ford',
      name2: '',
      street: 'Ruhrstr. 63',
      zip_code: '22761',
      city: 'Hamburg',
      phone: '',
      email: '',
      origin: 'DealerSearchService - Nearest Dealer from Publication ID',
      lease_man_delivery_id: '',
      address_line1: '',
      address_line2: '',
    },
  },
  customer: {
    document_signed_timestamp: '01.03.2019',
    ald_agreements: {
      data_storage: { answer: false },
      third_party_processing: { answer: false },
      terms_and_conditions: { answer: false },
    },
    idnow_agreements: { terms_and_conditions: { answer: false } },
    feedback: { given: false },
  },
  company_search_result: [
    {
      search_name: '',
      search_plz: '',
      bundesland: 'Freie und Hansestadt Hamburg',
      crefonummer: '2150032288',
      handelsName: null,
      identnummer: '02152150032288',
      land: 'DE',
      name: 'ALD AutoLeasing D GmbH',
      plz: 22529,
      ort: 'Hamburg',
      strasseHausnummer: 'Nedderfeld 95',
    },
    {
      search_name: '',
      search_plz: '',
      crefonummer: '2151330607',
      handelsName: null,
      identnummer: '02152151330607',
      name: 'ALD International GmbH',
      land: 'DE',
      bundesland: 'Freie und Hansestadt Hamburg',
      plz: 22529,
      ort: 'Hamburg',
      strasseHausnummer: 'Nedderfeld 95',
    },
    {
      search_name: '',
      search_plz: '',
      crefonummer: '2151310475',
      handelsName: null,
      identnummer: '02152151310475',
      name: 'ALD International Group Holdings GmbH',
      land: 'DE',
      bundesland: 'Freie und Hansestadt Hamburg',
      plz: 22529,
      ort: 'Hamburg',
      strasseHausnummer: 'Nedderfeld 95',
    },
    {
      search_name: '',
      search_plz: '',
      crefonummer: '2151634816',
      handelsName: null,
      identnummer: '02152151634816',
      name: 'Nedderfeld 95 Immobilien GmbH & Co. KG',
      land: 'DE',
      bundesland: 'Freie und Hansestadt Hamburg',
      plz: 22529,
      ort: 'Hamburg',
      strasseHausnummer: 'Nedderfeld 95',
    },
    {
      search_name: '',
      search_plz: '',
      crefonummer: '2150410987',
      handelsName: null,
      identnummer: '02152150410987',
      name: 'Interleasing Dello Hamburg G.m.b.H.',
      land: 'DE',
      bundesland: 'Freie und Hansestadt Hamburg',
      plz: 22529,
      ort: 'Hamburg',
      strasseHausnummer: 'Nedderfeld 95',
    },
  ],
};
